var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 782.039,
    height: 701.875,
    viewBox: "0 0 782.039 701.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.006 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.488,100.59l-25.446,6.562L270.537,188l-25.446,6.562a48.179,48.179,0,0,0-34.583,58.618L320.849,681.056a48.179,48.179,0,0,0,58.618,34.583l.066-.017L743.8,621.685l.066-.017a48.179,48.179,0,0,0,34.583-58.618L668.106,135.173A48.179,48.179,0,0,0,609.488,100.59Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.948,114.005l-30.139,7.772L278.69,200.2l-30.139,7.772a34.309,34.309,0,0,0-24.628,41.743L334.264,677.6a34.309,34.309,0,0,0,41.743,24.627l.066-.017L740.338,608.27l.066-.017a34.309,34.309,0,0,0,24.627-41.743L654.69,138.633a34.309,34.309,0,0,0-41.743-24.628Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.19,252.563l-184.273,47.52a8.014,8.014,0,1,1-4-15.52l184.273-47.52a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.955,270.5,412.671,326.274a8.014,8.014,0,0,1-4-15.52l216.284-55.775a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.458,369.937l-184.273,47.52a8.014,8.014,0,0,1-4-15.52l184.273-47.52a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.223,387.873,442.939,443.648a8.014,8.014,0,1,1-4-15.52l216.284-55.775a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.727,487.31l-184.273,47.52a8.014,8.014,0,1,1-4-15.52l184.273-47.52a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.492,505.246,473.208,561.021a8.014,8.014,0,0,1-4-15.521l216.284-55.775a8.014,8.014,0,1,1,4,15.52Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.459,348.809l-65.212,16.817a3.847,3.847,0,0,1-4.681-2.761L289.6,304.816a3.847,3.847,0,0,1,2.761-4.681l65.212-16.817a3.847,3.847,0,0,1,4.681,2.761l14.969,58.048a3.847,3.847,0,0,1-2.761,4.681Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.727,466.182,339.515,483a3.847,3.847,0,0,1-4.681-2.761L319.865,422.19a3.847,3.847,0,0,1,2.761-4.681l65.212-16.817a3.847,3.847,0,0,1,4.681,2.761L407.489,461.5a3.847,3.847,0,0,1-2.761,4.681Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,583.556l-65.212,16.817a3.847,3.847,0,0,1-4.681-2.761l-14.969-58.048a3.847,3.847,0,0,1,2.761-4.681l65.212-16.817a3.847,3.847,0,0,1,4.681,2.762l14.969,58.048A3.847,3.847,0,0,1,435,583.556Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.636,209.052H487.318a48.179,48.179,0,0,0-48.125,48.125V699.053a48.179,48.179,0,0,0,48.125,48.125H863.636a48.179,48.179,0,0,0,48.125-48.125V257.177a48.179,48.179,0,0,0-48.125-48.125Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.637,222.906H487.318a34.309,34.309,0,0,0-34.271,34.271V699.053a34.309,34.309,0,0,0,34.271,34.271H863.637a34.309,34.309,0,0,0,34.27-34.271V257.177a34.309,34.309,0,0,0-34.271-34.271Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-7.155 189.889)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.85,
    cy: 87.85,
    r: 87.85,
    transform: "translate(606.344 526.179)",
    fill: "#008d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.187,701.631H914.631V671.074a11.459,11.459,0,0,0-22.918,0v30.557H861.156a11.459,11.459,0,0,0,0,22.917h30.557V755.1a11.459,11.459,0,0,0,22.917,0V724.548h30.557a11.459,11.459,0,0,0,0-22.917Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-208.978 -99.06)",
    fill: "#008d9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-14.047 -99.06)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-208.978 42.765)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-14.047 36.679)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.859,390.607H506.513a3.847,3.847,0,0,1-3.843-3.843V285.817a3.847,3.847,0,0,1,3.843-3.843H635.859a3.847,3.847,0,0,1,3.843,3.843V386.764a3.847,3.847,0,0,1-3.843,3.843Z",
    transform: "translate(-208.978 189.888)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProject);
export default __webpack_public_path__ + "static/media/addProject.44962c76c795b94386f6a0f6f243046b.svg";
export { ForwardRef as ReactComponent };